import React from 'react'
import DisplayPriceBase from './DisplayPriceBase'
import DisplayPriceUiDefault from './DisplayPriceUiDefault'

class DisplayPrice extends React.Component {
    render() {
        return (
            <DisplayPriceBase {...this.props}>
                <DisplayPriceUiDefault/>
            </DisplayPriceBase>
        )
    }
}

export default DisplayPrice
